export default "__VITE_ASSET__DtQ2UqjO__"